'use client';

import { useRef } from 'react';

import { yup } from '@/lib/validation/yup';

export function useFormSchema<T extends yup.AnyObject>(
    builder: () => yup.ObjectSchema<T>
) {
    const schemaRef = useRef<yup.ObjectSchema<T>>(null);

    if (!schemaRef.current) {
        schemaRef.current = builder();
    }

    return schemaRef.current!;
}
